import React, { Fragment, useEffect, useState } from 'react'
import { Table, TableHead, TableBody, Panel, PanelHeader, PanelFooter, Modal, Search } from '../../shared'
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {
  getAdmins,
  createAdmin,
  validateInputs,
  selectAdmin,
  setAdmin,
  clearForm,
  updateAdmin,
  deleteAdmin, setAdmins
} from './admin-center-slice'
import {setDate} from '../../services/utils'
import {Button} from "../../ui-components";
import {CloseIcon, PlusIcon, EditIcon} from "../../assets";
import {togglePopover} from "../../admin/app-slice";
import AdminCenterForm from "./admin-center-form";
import './admin.module.scss'
import {Link} from "react-router-dom";

const AdminCenter = () => {
  const dispatch = useAppDispatch()
  const app = useAppSelector(state => state.adminApp)
  const {form, admins, adminCenter} = useAppSelector(state => state.adminCenter)
  const head = ['id', 'Название', 'Адрес', 'Телефон', 'Почта', 'Дата', '']
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false)
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [adminList, setAdminList] = useState<any[]>([])
  useEffect(() => {
    dispatch(getAdmins())
      .then(res => {
        if(res && res.length) {
          setAdminList(res)
        }
      })
  }, [dispatch])

  const submitForm = () => {

    for (const k in form) {
      dispatch(validateInputs({key: k, value: form[k]}))
    }

    if(adminCenter){
      return dispatch(updateAdmin())
        .then((res) => {
          if (res && res.length) {
            setAdminList(res)
          }
        } )
    }
    return dispatch(createAdmin())
  }

  const closePopover = () => {
    dispatch(setAdmin(null))
    dispatch(clearForm())
    dispatch(togglePopover('adminAddOrganization'))
  }

  const deleteOrg = async (organization) => {
    dispatch(clearForm())
    dispatch(setAdmin(null))
    dispatch(deleteAdmin(organization.uuid)).then(res => {
      if (res.deleted) {
        setDeleteModalOpen(false)
        dispatch(togglePopover('adminAddOrganization'))
        dispatch(getAdmins())
      }
    })
  }

  const rows = adminList.map((val: any) => {
    if(!val.deleted) {
      return (
        <div className='row' key={val.id}>
          <div className='item'>
            <Link to={`/organization/${val.uuid}`}>
              {val.id}
            </Link>
          </div>
          <div className='item' title={val.name}>
            <Link to={`/organization/${val.uuid}`}>
              <strong>{val.name}</strong>
            </Link>
          </div>
          <div className='item' title={val.address}>
            <Link to={`/organization/${val.uuid}`}>
              {val.address}
            </Link>
          </div>
          <div className='item' title={val.phone}>
            <Link to={`/organization/${val.uuid}`}>
              {val.phone}
            </Link>
          </div>
          <div className='item' title={val.email}>
            <Link to={`/organization/${val.uuid}`}>
              {val.email}
            </Link>
          </div>
          <div className='item' title={val.created_at}>
            <Link to={`/organization/${val.uuid}`}>
              {setDate(val.created_at, 'DD/MM/YY')}
            </Link>
          </div>
          <div className='item'>
            <EditIcon onClick={() => {
              dispatch(selectAdmin(val))
              dispatch(togglePopover('adminAddOrganization'))
            }}/>
          </div>
        </div>
      )
    }
  })

  const filterChange = (value: string) => {
    if (value) {
      setSearchQuery(value)
      // @ts-ignore
      setAdminList(admins.filter(h => h.name.toLowerCase().includes(value.toLowerCase())))
    } else {
      setSearchQuery('')
      setAdminList(admins)
    }
  }

  const popoverTitle = adminCenter ? 'Сохранить' : 'Создать'

  return (
    <Fragment>
      <div id='emergency-list'>
        <div className={'mb-20 flex-end d-flex'}>
          <Search handleChange={e => {
            filterChange(e.target.value)
          }} value={searchQuery}/>
          <Button type='contained'
                  color='secondary'
                  onClick={() => dispatch(togglePopover('adminAddOrganization'))}
                  startIcon={<PlusIcon/>}>Добавить</Button>
        </div>
        <Table>
          <TableHead>
            {head.map((el, i) => <div className='item' key={i}>{el}</div>)}
          </TableHead>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </div>
      <Panel open={app.adminAddOrganization}
             handleClose={() =>closePopover()}>
        <PanelHeader className='simple-header'>
          <p>{popoverTitle} Центрального Администратора</p>
          <CloseIcon onClick={() => closePopover()}/>
        </PanelHeader>
        <AdminCenterForm admin={adminCenter}/>
        <PanelFooter className='action-box'>
          {adminCenter && <Button type='contained' onClick={() => setDeleteModalOpen(true)} className='ml-20'>Удалить</Button>}
          <Button type='simple' onClick={() => closePopover()}>Отмена</Button>
          <Button type='contained' onClick={submitForm} className='ml-20'>{popoverTitle}</Button>
        </PanelFooter>
      </Panel>
      <Modal open={deleteModalOpen}
             closeIcon
             title={'Удалить организацию?'}
             handleClose={() => {
               setDeleteModalOpen(false)
             }}>
        <p className="modalText mb-50">Вы уверены, что хотите удалить эту организацию?</p>
        <div className='d-flex space-between'>
          <Button type='contained'
                  fullWidth
                  onClick={() => deleteOrg(adminCenter)}>Да</Button>
          <Button className={`ml-30`}
                  fullWidth
                  type='outlined'
                  onClick={() => setDeleteModalOpen(false)}>Нет</Button>
        </div>
      </Modal>
    </Fragment>
  )
}

export default AdminCenter
